import { IonButton, IonContent, IonIcon, IonItem, IonLabel, IonList, IonPopover, IonRow } from "@ionic/react";
import React, { FC, ReactElement } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../../../reducers/UserReducer";
import { chevronDown, copyOutline, createOutline } from "ionicons/icons";
import { isMobile } from "react-device-detect";
import { isStaff } from "../../extras/Functions";
import CheckRole from "../../extras/CheckRole";
import NotificationPopUp from "../../extras/NotificationPopUp";
import { default as add_building_icon } from "../../../AE2/static/icons/add_building_icon.svg";

interface IProps {
    date:Date
    customerName?:string,
    customerId?:string,
    subtitle?:ReactElement
};

const WelcomeRow:FC<IProps> = ({date, customerName, customerId, subtitle}) => {
    const user = useSelector(selectUser)

    const formatDate = () =>{
        const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric', hour:'numeric', minute:'numeric', second:undefined, timeZone: 'America/Chicago'};
        return date.toLocaleTimeString('en-US', options);
    }

    const copyCustomerId = () => {
        if (!customerId) return
        navigator.clipboard.writeText(customerId)
            .then(() => NotificationPopUp('success', 'Customer ID copied to clipboard', 'Copied', 2000))
            .catch(() => NotificationPopUp('error', 'Could not copy the customer ID', 'Copy Failed'))
    }

    if( !user){
        return null
    }

    

    return <IonRow className="w-100 ion-justify-content-between">
        <div style={{margin:'1rem'}}>
            {customerName ? <>
                {! isStaff(user) ?
                <div className="text-dark-blue font-med font-helvetica font-12pt">Welcome back,</div> : null}
                <div className="text-dark-blue font-med font-helvetica font-27pt">{customerName}</div>
                {isStaff(user) ? subtitle : null}
            </> : <>
                <div className="text-dark-blue font-med font-helvetica font-27pt">Welcome back, {user.first_name}</div>
                <div className="text-dark-blue font-med font-helvetica font-14pt" style={{marginTop:'1rem'}}>Your energy performance dashboard</div>
            </>}
        </div>
        <div className="w-100">
            <div style={{display:'flex',alignItems:'center', justifyContent:'flex-end'}}>
                <div className="text-footer-blue font-med font-helvetica font-13pt" style={isMobile ? {fontSize:'12px'} : {marginRight:'2rem'}}>Date Refreshed: {formatDate()}</div>
                {isStaff(user)?
                <>
                <IonButton id="quick-actions-btn" size={isMobile?'small':'default'}>
                    <IonLabel className="text-white  font-bold font-helvetica font-10pt" style={{textTransform:'none'}} >Quick Actions</IonLabel>
                    <IonIcon slot='end' src={chevronDown}/>
                </IonButton>
                {customerId ?
                <IonPopover trigger="quick-actions-btn" dismissOnSelect={true} showBackdrop={false} side="bottom" alignment="end">
                    <IonContent>
                        <IonList lines="none">
                            {CheckRole(user, ["Admin", "Supervisor"]) ?
                            <IonItem button detail={false} href={`/customer/${customerId}/edit`}>
                                <IonIcon slot="start" src={createOutline}/>
                                <IonLabel>Edit Customer</IonLabel>
                            </IonItem> : null}
                            <IonItem button detail={false} onClick={copyCustomerId}>
                                <IonIcon slot="start" src={copyOutline}/>
                                <IonLabel>Copy ID</IonLabel>
                            </IonItem>
                            <IonItem button detail={false} href={`/customer/${customerId}/addproperty`}>
                                <IonIcon slot="start" src={add_building_icon} style={{filter:'brightness(0)'}}/>
                                <IonLabel>Add Building</IonLabel>
                            </IonItem>
                        </IonList>
                    </IonContent>
                </IonPopover> : null}
                </>:
                null }
            </div>
        </div>
    </IonRow>
};

export default WelcomeRow;